import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';
import Input from '../../components/input/input';
import Validation from '../../components/validation/validation';

function LoginPage(props) {
    const [email, setEmail] = useState(props.model.username || '');
    const loginForm = useRef();

    useEffect(() => {
        if (props.model.errors.length > 0 && loginForm.current) {
            loginForm.current.showError('Username', () => '');
            loginForm.current.validateAll();
        }
    }, [props.model.errors]);

    const handleEmailChange = useCallback(value => {
        loginForm.current.hideError('Username');
        setEmail(value.trim());
    }, [setEmail]);

    const beforeSubmit = new Promise(resolve => (
        setTimeout(() => (resolve()), 10)
    ));

    return (
        <AuthWrapper heading="Welcome!">
            <Validation.Form
                method="post"
                ref={loginForm}
                resolveBeforeSubmit={beforeSubmit}
                action="/Account/EnterPassword"
            >
                <input type="hidden" name="ReturnUrl" value={props.model.returnUrl || ''} />
                <section className="sten-content__section">
                    <Validation.Wrapper validations={{ required: true, email: true }}>
                        <Input
                            name="Username"
                            className="sten-input--sm"
                            type="text"
                            id="Username"
                            placeholder="Email"
                            value={email}
                            onChange={handleEmailChange}
                            showKeyboard
                        />
                    </Validation.Wrapper>
                </section>
                <section className="sten-content__section sten-content__section--lg">
                    <Validation.Button className="btn btn--primary btn--sm col-24" value="EnterPassword">
                        Continue
                    </Validation.Button>
                </section>
                <input name="__RequestVerificationToken" type="hidden" value={props.token} />
            </Validation.Form>
        </AuthWrapper>
    );
}

LoginPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default LoginPage;
